import { render, staticRenderFns } from "./Synchro.vue?vue&type=template&id=62e5c48e"
import script from "./Synchro.vue?vue&type=script&lang=js"
export * from "./Synchro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports